import { http } from "..";
import { queryBuilder } from "../../utils/helper";

/**
 * Gets notifications
 *
 * @param {object} filter
 * @param {boolean} filter.isRead
 * @returns axios http response
 */
export const getNotifications = (filter: {}) => {
  const query = queryBuilder(filter);
  return http.get(`/notifications${query}`);
};

/**
 * Read notification
 *
 * @param {string} notificationId
 * @returns axios http response
 */
export const readNotification = (notificationId: string) => {
  return http.patch(`/notifications/${notificationId}`);
};


/**
 * Clear all notifications
 * 
 * @returns axios http response
 */
export const clearAllNotifications = () => {
  return http.patch(`/notifications/clear`);
}